<template>
    <div class="w-full flex flex-wrap" :class="$attrs['class']">
        <a href="javascript:void(0);" tabindex="-1" v-text="linkText" @click.prevent="expanded = !expanded" class="text-green-500 text-sm mt-2 underline hover:text-green-500 font-semibold focus:outline-none"></a>
        <transition name="slide-open">
            <div class="w-full flex flex-wrap origin-top-left" v-if="expanded">
                <div class="form-tooltip-arrow"></div>
                <div class="p-3 form-tooltip w-full">
                    <slot></slot>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    data() {
        return {
            expanded: false
        }
    },
    computed: {
        linkText() {
            return this.expanded ? 'Hide more info' : 'More info';
        }
    },
    watch: {
        expanded(value) {
            if (value === true){
                window.amplitude.tooltipEvent(this.$parent.name, this.$parent.$parent.tooltip);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.form-tooltip {
    font-size: 13px;
    line-height: 138%;
    color: #555555;
    background: #D5EAED;
    position: relative;
    // margin-top: 15px;

}

.form-tooltip-arrow {
    content: '';
    display: block;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 13px 0 0 11px;
    border-color: transparent transparent transparent #D5EAED;
}

.slide-open-enter-active {
    max-height: 100px;
    transition: all .5s cubic-bezier(0.175, 0.885, 0.32, 1.05);
}
.slide-open-leave-active {
    max-height: 100px;
    transition: all .5s ease-out;
}
.slide-open-enter, .slide-open-leave-to {
    transform: scale(0);
    max-height: 0px;
    overflow: visible;
}
</style>